import React from 'react';
import { Box, Container, Grid, Typography, Link, useTheme } from '@mui/material';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import XIcon from '@mui/icons-material/X';
import FacebookIcon from '@mui/icons-material/Facebook';
import CopyrightIcon from '@mui/icons-material/Copyright';
import { CYBER_CONFIG } from '../../constants';

const FooterLinks: React.FC = () => {
  const theme = useTheme();
  const currentYear = new Date().getFullYear();

  const socialLinks = [
    {
      name: 'LinkedIn',
      icon: <LinkedInIcon sx={{ fontSize: 24 }} />,
      url: CYBER_CONFIG.footer.socialLinks.linkedin,
    },
    {
      name: 'X',
      icon: <XIcon sx={{ fontSize: 24 }} />,
      url: CYBER_CONFIG.footer.socialLinks.x,
    },
    {
      name: 'Facebook',
      icon: <FacebookIcon sx={{ fontSize: 24 }} />,
      url: CYBER_CONFIG.footer.socialLinks.facebook,
    },
  ];

  const footerLinks = CYBER_CONFIG.footer.links;

  return (
    <Box
      component="footer"
      sx={{
        backgroundColor: 'black',
        color: 'white',
        pt: 4,
        pb: 6,
        position: 'relative',
      }}
    >
      <Container maxWidth={false} disableGutters>
        {/* Social Media Links and By Qlik */}
        <Grid container spacing={2} sx={{ mb: 3, mx: 2 }}>
          <Grid size={{ xs: 12, md: 6 }}>
            <Box
              sx={{
                display: 'flex',
                gap: 2,
                justifyContent: { xs: 'center', md: 'flex-start' },
              }}
            >
              {socialLinks.map((social) => (
                <Link
                  key={social.name}
                  href={social.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  data-social-bookmark={social.name}
                  sx={{
                    color: 'white',
                    cursor: 'pointer',
                    display: 'inline-flex',
                    alignItems: 'center',
                    '&:hover': {
                      color: theme.palette.primary.main,
                    },
                  }}
                >
                  {social.icon}
                </Link>
              ))}
            </Box>
          </Grid>
          <Grid size={{ xs: 12, md: 6 }}>
            <Box
              sx={{
                display: 'flex',
                justifyContent: { xs: 'center', md: 'flex-end' },
                alignItems: 'center',
              }}
            >
              <Box
                component="img"
                src="/assets/images/by-qlik/Analytics-By-Qlik-Mark-Horizontal-noRule_white.png"
                alt="Analytics By Qlik"
                sx={{
                  height: 'auto',
                  maxWidth: '200px',
                  width: '100%',
                }}
              />
            </Box>
          </Grid>
        </Grid>

        {/* Footer Links */}
        <Box
          sx={{
            display: 'flex',
            flexWrap: 'wrap',
            justifyContent: 'flex-start',
            gap: { xs: 1, md: 2 },
            mb: 2,
            ml: 2,
            
          }}
        >
          {/* Copyright */}
          <Typography
            variant="body2"
            color='primary.contrastText'
            sx={{
              display: 'flex',
              alignItems: 'center',
              borderRight: { xs: 'none', md: '1px solid rgba(255, 255, 255, 0.3)' },
              pr: { xs: 0, md: 2 },
              mb: { xs: 1, md: 0 },
            }}
          >
            <CopyrightIcon sx={{ fontSize: 16, mr: 0.5 }} /> {currentYear} Chubb
          </Typography>

          {/* Links */}
          {footerLinks.map((link, index) => (
            <Link
              key={index}
              href={link.url}
              target="_blank"
              rel="noopener noreferrer"
              data-cta={link.cta}
              sx={{
                color: 'var(--mui-custom-grey)',
                // textDecoration: 'none',
                fontSize: '0.875rem',
                fontFamily: theme.typography.fontFamily,
                cursor: 'pointer',
                '&:hover': {
                  textDecoration: 'underline',
                  color: theme.palette.primary.main,
                },
              }}
            >
              {link.text}
            </Link>
          ))}

          {/* Cookie Policy - internal link */}
          <Link
            href="/cookie-policy"
            data-cta="Footer: Cookie Policy"
            sx={{
              color: 'var(--mui-custom-grey)',
            //   textDecoration: 'none',
              fontSize: '0.875rem',
              fontFamily: theme.typography.fontFamily,
              cursor: 'pointer',
              '&:hover': {
                textDecoration: 'underline',
                color: theme.palette.primary.main,
              },
            }}
          >
            Cookie Policy
          </Link>
          <Link
            className='ot-sdk-show-settings'
            sx={{
              color: 'var(--mui-custom-grey)',
            //   textDecoration: 'none',
              fontSize: '0.875rem',
              fontFamily: theme.typography.fontFamily,
              cursor: 'pointer',
              '&:hover': {
                textDecoration: 'underline',
                color: theme.palette.primary.main,
              },
            }}
          >
            Do Not Sell Or Share My Personal Information
          </Link>
        </Box>

        {/* Privacy Notice */}
        <Box
          sx={{
            display: 'flex',
            flexWrap: 'wrap',
            justifyContent: 'flex-start',
            gap: { xs: 1, md: 2 },
            mb: 2,
            mx: 2,
            
          }}
        >
            <Typography
                variant="body2"
                color='primary.contrastText'
                sx={{
                    display: 'block',
                    textAlign: 'left',
                    fontStyle: 'italic',
                }}
            >
                Chubb uses your personal information in accordance with the privacy policy applicable to your country. To view
                your country's policy, please go to{' '}
            <Link
                href="https://www.chubb.com"
                target="_blank"
                rel="noopener noreferrer"
                underline='none'
                sx={{
                color: 'primary.main',
                '&:hover': {
                    color: theme.palette.primary.main,
                },
                }}
            >
                chubb.com
            </Link>{' '}
            and click on the link(s) at the bottom of the page.
            </Typography>
        </Box>
      </Container>
    </Box>
  );
};

export default FooterLinks;
